// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__KbYYs","upload":"Small_upload__2lMHq","imageWrap":"Small_imageWrap__1_pIU","removeBtn":"Small_removeBtn__2NKn-"};